module.exports = { "default": require("core-js/library/fn/object/freeze"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// /opt/atlassian/pipelines/agent/build/~/babel-runtime/core-js/object/freeze.js
// module id = 205
// module chunks = 0